var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-time-select',_vm._g(_vm._b({ref:"gjInput",style:({width: _vm.width}),attrs:{"size":_vm.mapSize,"placeholder":_vm.placeholder}},'el-time-select',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }